import { Component, Input } from '@angular/core';
import { PAYMENT_TYPES } from 'services/payment/payment.interface';
import { FeesStepInstance } from 'services/professional/step/step.interface';
import { environment } from 'environments/environment';
import { PAYMENT_FORM_PLACE } from 'features/payment-form/payment-form.constants';

@Component({
  selector: 'cm-epay-form',
  templateUrl: './epay-form.component.html',
  styleUrls: ['./epay-form.component.scss'],
})
export class EPayFormComponent {
  @Input() paymentAmount;
  @Input() step: FeesStepInstance;
  @Input() paymentPlace: PAYMENT_FORM_PLACE;

  getData() {
    return {
      data: {
        pages: {
          current: window.location.origin + window.location.pathname,
          success: `${window.location.origin}/payment-checkout/success?redirectPath=${window.location.pathname}`,
          error: `${window.location.origin}/payment-checkout/failed?redirectPath=${window.location.pathname}`,
        },
        step_instance_id: this.step.step_instance_id,
        amount: this.paymentAmount,
        payment_place: this.paymentPlace,
      },
      type: PAYMENT_TYPES.EPAY,
      callback: ({ type, UID }: { type: PAYMENT_TYPES; UID: string }) => {
        if (type !== PAYMENT_TYPES.EPAY) {
          return;
        }
        window.location.href = environment.ePayPaymentPath + `?Page=${UID}`;
      },
    };
  }
}
